import { IApplicationState } from '../../types/redux';

export const selectGuestRatingInfo = (state: IApplicationState) => state.guestRating;
